// extracted by mini-css-extract-plugin
export default {"container":"PCfONe","mobile":"ffVChd","loader":"FVDlRz","button":"OaUYT1","loading":"OFyGQZ"};